import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators  } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-campus-create',
  templateUrl: './campus-create.component.html',
  styleUrls: ['./campus-create.component.scss']
})
export class CampusCreateComponent implements OnInit {

  constructor(private http: HttpClient, private formBuilder: FormBuilder, @Inject('API_ENDPOINT') private api_endpoint: string) { }

  public campusoverviewForm: FormGroup;
  submitted = false;
  message = null;
  class = null;
  action = null;

  ngOnInit() {
    this.campusoverviewForm = this.formBuilder.group({
      overview: ['', Validators.required],
      overviewlist1: ['', [Validators.required]],
      overviewlist2: ['', [Validators.required]],
      seohidden: [''],
      _id: [''],
    });

    this.http.get<any>(this.api_endpoint+'/campusoverviewfindone/').subscribe(
      data => {
        if(data.data != null){
          this.action = 'Update';
          this.campusoverviewForm.patchValue({
            overview: data.data.overview,
            overviewlist1: data.data.overviewlist1,
            overviewlist2: data.data.overviewlist2,
            _id: data.data._id,
          })
        }else{
          this.action = 'Submit';
          this.campusoverviewForm.patchValue({
            overview: '',
            overviewlist1: '',
            overviewlist2: '',
            _id: '',
          })
        }
    },
    (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
    });

  }

  get f() { return this.campusoverviewForm.controls; }

  onFormSubmit(action){
    // alert(action);
    console.log(this.campusoverviewForm.value);

    this.submitted = true;
    if(action == 'Update'){
      var data = {
        "overview" : this.campusoverviewForm.value.overview,
        "overviewlist1" : this.campusoverviewForm.value.overviewlist1,
        "overviewlist2" : this.campusoverviewForm.value.overviewlist2,
        "_id" : this.campusoverviewForm.value._id,
        "admin" : sessionStorage.getItem('adminName'),
        "seohidden" : this.campusoverviewForm.value.seohidden
      };
      this.http.put<any>(this.api_endpoint+'/campusoverview', data).subscribe(
        res => {
          console.log(res);
          if(res.Error){
            this.message = res.Error;
            this.class = 'btn btn-primary';
            return
          }else{
            this.message = 'Successfully Updated';
            this.class = 'btn btn-success';
          } 
          window.location.reload();
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    }else if(action == 'Submit'){
      var data1 = {
        "overview" : this.campusoverviewForm.value.overview,
        "overviewlist1" : this.campusoverviewForm.value.overviewlist1,
        "overviewlist2" : this.campusoverviewForm.value.overviewlist2,
        "admin" : sessionStorage.getItem('adminName'),
        "seohidden" : this.campusoverviewForm.value.seohidden
      };
      this.http.post<any>(this.api_endpoint+'/campusoverview', data1).subscribe(
        res => {
          console.log(res);
          if(res.Error){
            this.message = res.Error;
            this.class = 'btn btn-primary';
            return
          }else{
            this.message = 'Successfully Added';
            this.class = 'btn btn-success';
          } 
          window.location.reload();
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    }
  }

}
